import { Point } from "highcharts";
import { grey } from "@mui/material/colors";
import { HighchartsChartDataType } from "@/storybook/c8r-highcharts/common/utils/types/common";
import { money } from "@/utils/numeral/money";

export const getResourceDetailsCostsChartTooltipValueFormatter = (
  totals: Record<number, number>,
  chartData?: HighchartsChartDataType | null,
) => {
  return (point: Point) => {
    const costBasedData = chartData?.series.find(
      (series) => series.name === point.series.name,
    )?.data;

    const value = costBasedData?.[point.index]?.y;

    return `
    <div style="font-size: 13px; color: #666; margin-bottom: 8px;">${point.category}</div>  
      <div style="display: flex; flex-direction: column; gap: 8px;">
        <div style="display: flex; justify-content: space-between; align-items: center;">
            <span style="display: flex; align-items: center; font-size: 11px; margin-right: 16px;">
                <span style="font-weight: 500; font-size: 13px; width:${point.series.name.length * 10}px; max-width: 250px; min-width: 35px; word-break: break-word; white-space: normal; padding-left: 8px; border-left: 3px solid ${point.color}">
                    ${point.series.name}
                </span>
            </span>

          <span style="font-weight: bold; font-size: 13px; "> ${money(value)}</span>
        </div>
      </div>
      <div style="
                margin-top: 10px;
                padding-top: 6px;
                display: flex;
                justify-content: space-between;
                font-weight: 500;
                font-size: 13px;
                color: ${grey[600]};
            "><span>Total Cost</span><b>${money(totals[point.index])}</b></div>
      `;
  };
};
